<template>
  <v-text-field
    solo
    outlined
    flat
    class="focus-input primary"
    hide-details="false"
    type="search"
    :placeholder="$t('Default.search_dots')"
    dense
    height="44px"
    width="100%"
    :value="value"
    @input="$emit('input', $event)"
    @keyup.enter="$emit('search')"
  />
</template>

<script>
export default {
  name: 'AdminSearchInput',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>
